
import { Fragment, useEffect,useState } from 'react';
import { FaUnderline } from 'react-icons/fa6';
import { Link, useLocation} from 'react-router-dom';
import { useParams } from "react-router-dom";
// commit
function withLineBreaks(text) {
    // check for <br /> or /n or /r/n
    const lineBreakSymbols = /<br\s*\/?>|\r?\n/i;
    return text.split(lineBreakSymbols).join("<br />");
}

// ok so when peopel visit a page directly 
// event is null so how do we make event not null?

export default function ExpandedEvent({ event:initialEvent, handleBack }) {

    const [event, setEvent] = useState(initialEvent);
    const location = useLocation();
    const fullUrl = `${window.location.origin}${location.pathname}${location.search}`;
    const stripIndex = fullUrl.indexOf("=")
    const stripLength = fullUrl.length
    const strippedUrl = fullUrl.slice(stripIndex+1,stripLength)

    useEffect( () => {
        if(!event)
            {
             fetch("https://socalfurs.com/databaseconnect.php")
                 .then((response) => response.json()) 
                 .then(data => {
                    
                     const foundEvent = data.events.find((e) => e.id === strippedUrl)
                 if(foundEvent)
                    {
                    setEvent(foundEvent)
                 }

                 })
                 .catch((error) => console.error("Error fetching data:", error)); 

                
        }
    
        

    },[event,strippedUrl])


  
    const handleShare = async () => {


        if (navigator.share) {
            
            try {
                await navigator.share({
                    title: event.summary,
                    text: "View this event on SocalFurs!",
                    url: fullUrl
                });
            } catch (error) {
                if (error.name !== "AbortError") console.log("There was a problem.")
            }
        } else {    
            alert("Your browser doesn't support this.");
        }
    }

    const handleCopy = () => {
        navigator.clipboard.writeText(fullUrl)
            .then(() => {
                console.log("Copied!")
            })
            .catch(err => {
                alert("There was a problem.");
            })
    }

    return (
        <div className="event">
                  {event ? (
                          <>
                                                  <button
                                             className="event-back"
                                             onClick={() => handleBack()}
                                         >
                                             <div className="btn-icon-circle">
                                                 {/* Left Caret Icon */}
                                                 <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style={{marginLeft: -2}}>
                                                     <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 19.5 8.25 12l7.5-7.5" />
                                                 </svg>
                                             </div>
                                         </button>

                                         <span className="event-header">{event.summary}</span>
                                         <div className="event-info-line">
                                             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="rgb(60, 163, 204)">
                                                 <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                                                 <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
                                             </svg>
                                             <span>{event.location}</span>
                                         </div>
                                         <div className="event-info-line">
                                             <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="rgb(60, 163, 204)">
                                                 <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                             </svg>
                                             <span>{event.date}</span>
                                         </div>
                                         <div className="event-page-description">
                                             <h6>Description</h6>
                                             <span dangerouslySetInnerHTML={{__html: withLineBreaks(event.description)}}></span>
                                         </div>
                                         <Link className='event-action' to={event.html_link}>
                                             <button>See on Google Calendar</button>
                                         </Link>
                                         <Link className='event-action' to={event.telegramLink}>
                                             <button>Join the Telegram</button>
                                         </Link>
                                         {navigator.share && (
                                             <button onClick={handleShare} className='share-btn'>
                                                 Share Event
                                             </button>
                                         )}
                                         {navigator.clipboard && (
                                             <div className="sharelink">
                                                 <input
                                                     type="text"
                                                     value={fullUrl}
                                                     readOnly
                                                 />
                                                 <button onClick={handleCopy}>Copy</button>
                                             </div>
                                         )}
                                        
                                 </>    
                  

                  ) : (
                    <>
                       <div>Loading Event ...</div>
                       
                    </>

                  )}

                        


                    
                        
 
          </div>                         
                                   
    
    );

    
}
